import { Component, inject } from '@angular/core';
import { BRCBaseComponent } from '@brc/hrt-base-component';
import { ButtonV3Component, ColumnRendererComponentV3, ComplexDialogV3Service } from '@gea/digital-ui-lib';
import { TranslatePipe } from '@ngx-translate/core';
import { PredictiveAlert } from '@shared/models';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-root-cause-btn',
  imports: [ButtonV3Component, TranslatePipe],
  template: ` <geaui-button-v3 type="tertiary" (click)="openRootCauseDialog()">
    {{ 'ROOT_CAUSE.OPEN_BUTTON' | translate }}
  </geaui-button-v3>`,
})
export class RootCauseButtonComponent extends BRCBaseComponent implements ColumnRendererComponentV3<PredictiveAlert> {
  readonly rowData!: PredictiveAlert;
  private readonly dialogService = inject(ComplexDialogV3Service);

  async openRootCauseDialog() {
    const { RootCauseDialogComponent } = await import('../predictive-alerts/root-cause-dialog.component');

    const data = { rootCauses: this.rowData?.predictive_alert_rootcauses };

    this.dialogService.open(
      {
        header: `ROOT_CAUSE.TITLE`,
        closable: true,
        hideButtons: true,
        data,
        width: '80vw',
      },
      RootCauseDialogComponent
    );
  }
}
